import { render, staticRenderFns } from "./InstructionExam.vue?vue&type=template&id=a98f2828&scoped=true"
import script from "./InstructionExam.vue?vue&type=script&lang=js"
export * from "./InstructionExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98f2828",
  null
  
)

export default component.exports